<template>
    <div class="w-full">
        <div
v-if="Object.keys(product).length > 0"
            class="myHappyHomeLandingPage relative border-1 rounded-[20px] min-w-full  p-[20px] pb-[40px] mb-[50px] bg-opacity-50 bg-[#fff] border-[#CCCCCC]"
>
            <div class="border-0 p-[20px] shadow-[0px_0px_10px_0px_#0000001A] rounded-[20px] bg-[#fff]">
                <div class="flex items-center gap-[12px]">
                    <div class="flex items-center gap-[5px]">
                        <span class="block w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
                        <span class="block w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
                    </div>
                    <h1 class="m-0 text-[20px] font-roboto font-bold text-[#9336B4]">
Omega
</h1>
                </div>
                <div class="flex flex-col my-[20px]">
                    <div class="pb-[10px] mb-[10px] border-b border-[#EFEFEF]">
                        <h2 class="mb-[10px] text-[22px] font-medium font-roboto text-[#333]">
{{ product.bundle_name }}
                        </h2>
                        <p
v-if="product.description.length > 0"
                            class="m-0 text-[14px] font-normal font-roboto text-[#666]"
>
{{ product.description }}
</p>
                    </div>
                    <div class="text-right">
                        <h6 class="mb-[5px] text-[20px] font-medium font-roboto text-[#EA8A8A]">
{{ product.months }}
                            months plan
</h6>
                        <h2 class="m-0 text-[40px] font-bold font-roboto text-[#333]">
${{
                            $helper.formatAmount(product.amount) }}<span class="text-[30px]">/mo</span>
                        </h2>
                    </div>
                </div>
                <addons :addons="getAddonData(product.plans)" />
            </div>
            <button
class="absolute -bottom-5 right-[20px] text-[14px] font-roboto font-medium rounded-full py-[10px] px-[20px] text-[#fff] bg-[#29C6CD]"
                @click="continueClicked"
>
Continue
                to Checkout
</button>
        </div>
    </div>

    <!-- Addons Modal -->
    <addonsModal ref="addonsModalRef" />
</template>

<script>
import { data } from 'jquery';
import addons from '../../components/nest_components/addons/addons.vue';
import addonsModal from '../../components/nest_components/addons/addons_modal.vue';
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        addons,
        addonsModal
    },

    computed: {
        ...mapGetters([
            "selectedProtectionPlan",
            "protectionPlanBundle",
            "cartValidate",
            "removeProtectionCartData",
            "cartUpdated"

        ]),

    },

    watch: {

        selectedProtectionPlan: function (data) {
            this.getBundleData()
        },

        protectionPlanBundle: function (data) {
            if (data.length > 0)
                this.product = data[0]
        },

        removeProtectionCartData: function (data) {

            this.upsertCart({
                "bundle_id": this.product.id,
                "quantity": 1,
                "partner_id": this.product.partner_id ? this.product.partner_id : this.selectedProtectionPlan.partner_id
            })

        },
        cartValidate: function (data) {

            if (this.cartValidate.validation_passed) {

                this.upsertCart({
                    "bundle_id": this.product.id,
                    "quantity": 1,
                    "partner_id": this.product.partner_id ? this.product.partner_id : this.selectedProtectionPlan.partner_id
                })

            }
            else {

                this.$confirmDialog.show({
                    title: "Action Required",
                    message: this.cartValidate.message,

                    onConfirm: () => {
                        this.removeBundle(this.cartValidate)
                    },
                });
            }

        },

        cartUpdated: function (data) {

            this.isLoading = true
            this.getCartCount({})
            this.getBundleData()

        },

        cartCountResponse: function (data) {
            this.$refs.addonsModalRef.openModal();
            
        }
    },

    data() {
        return {
            isLoading: true,
            product: {},

        };
    },


    mounted() {
    },
    methods: {

        ...mapActions([
            "getProtectionPlansBundle",
            "validateCart",
            "removeProtectionItemCart",
            "upsertCart",
            "getCartCount",
            "cartCountResponse",

        ]),

        removeBundle(data) {
            this.removeProtectionItemCart({
                "bundle_ids": data.bundle_ids,
                "plan_ids": data.plan_ids,
            })
        },


        getAddonData(data) {
            const groupedData = data.reduce((acc, item) => {
                const key = item.trade_name;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});
            return groupedData
        },
        continueClicked() {

            if (this.product.quantity == 0) {
                this.validateCart({
                    "bundle_id": this.product.id,
                    "quantity": 1,
                    "partner_id": this.product.partner_id ? this.product.partner_id : this.selectedProtectionPlan.partner_id

                })
            }
            else {
                this.$refs.addonsModalRef.openModal();
            }


        },


        getBundleData() {
            if (this.isLoading) {
                this.isLoading = false
                this.getProtectionPlansBundle({ 'partner_id': this.selectedProtectionPlan.partner_id, "route_slug": this.selectedProtectionPlan.route_slug });
            }
        },



    },
};
</script>